import bookingPageEn from "./en/bookingPage";
import bookingPageTh from "./th/bookingPage";
import bookingPageCh from "./ch/bookingPage"
import businessPageEn from "./en/businessPage";
import businessPageTh from "./th/businessPage";
import businessPageCh from "./ch/businessPage";
import candidatePageTh from "./th/candidatePage";
import candidatePageEn from "./en/candidatePage";
import candidatePageCh from "./ch/candidatePage";
import ExtraTextTh from "./th/extraText";
import ExtraTextEn from "./en/extraText";
import ExtraTextCh from "./ch/extraText";
import NavMenuTh from "./th/navigationMenu";
import NavMenuEn from "./en/navigationMenu";
import NavMenuCh from "./ch/navigationMenu";
import manageBookingTh from "./th/manageBooking";
import manageBookingEn from "./en/manageBooking";
import manageBookingCh from "./ch/manageBooking";
import alertNotificationTh from "./th/alertNotification";
import alertNotificationEn from "./en/alertNotification";
import alertNotificationCh from "./ch/alertNotification";

export default {
  en: {
    bp: bookingPageEn,
    busiP: businessPageEn,
    cp: candidatePageEn,
    extra: ExtraTextEn,
    nav: NavMenuEn,
    mbp: manageBookingEn,
    alert: alertNotificationEn
  },
  th: {
    bp: bookingPageTh,
    busiP: businessPageTh,
    cp: candidatePageTh,
    extra: ExtraTextTh,
    nav: NavMenuTh,
    mbp: manageBookingTh,
    alert: alertNotificationTh
  },
  ch: {
    bp: bookingPageCh,
    busiP: businessPageCh,
    cp: candidatePageCh,
    extra: ExtraTextCh,
    nav: NavMenuCh,
    mbp: manageBookingCh,
    alert: alertNotificationCh
  }
};
